export default __webpack_public_path__ + "static/22-88d112dd5004693e747d1e45e3abc223.png";